module.exports = __webpack_public_path__ + "img/70.8.TSS.688c5547.png";